import {Injectable} from '@angular/core';
import {CentreProperty, SelfServiceService} from '../../generated/sales-terminal-client';
import {ViewService} from '../view/view.service';

@Injectable({
  providedIn: 'root'
})
export class CentrePropertyService {
  public centreProperties: CentreProperty[] = [];

  private get getOrigin(): string {
    return this.viewService.conf.environment === 'LOCAL' ? 'https://piletilevi.test' : window.location.origin;
  }

  constructor(private selfService: SelfServiceService,
              private viewService: ViewService) {
    this.fetchCentreProperties();
  }

  public fetchCentreProperties(salespointId?: number): void {
    this.selfService.getCentreProperties(this.getOrigin, salespointId).subscribe((result: CentreProperty[]) => {
      this.centreProperties = result;
    });
  }

  public getValue(property: string): string {
    const foundProperty = this.centreProperties?.filter(cp => cp.key === property);
    if (foundProperty?.length === 1) {
      return foundProperty[0].value;
    }
    return null;
  }

  public isEnabled(property: string): boolean {
    return this.getValue(property) === 'true';
  }
}
